(function () {
  function init() {
    var form = document.getElementById('KojiContactForm');
    var feedback = document.getElementById('KojiContactSuccess') || document.getElementById('KojiContactErrors');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // FAQ: aprendo una domanda si chiude quella gia aperta
    var faqItems = document.querySelectorAll('.koji-faq-list details.koji-faq-item');
    for (var f = 0; f < faqItems.length; f++) {
      (function (current) {
        current.addEventListener('toggle', function () {
          if (!current.open) return;
          for (var k = 0; k < faqItems.length; k++) {
            if (faqItems[k] !== current && faqItems[k].open) faqItems[k].open = false;
          }
        });
      })(faqItems[f]);
    }

    // Pulsante delle FAQ: porta al modulo e mette il cursore sul primo campo
    var ctas = document.querySelectorAll('[data-koji-scroll]');
    for (var i = 0; i < ctas.length; i++) {
      ctas[i].addEventListener('click', function (e) {
        var target = document.getElementById('KojiContactBlock');
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        var first = document.getElementById('KojiContactName');
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, reduce ? 0 : 500);
      });
    }

    // Dopo l'invio (o con errori) porta l'utente al messaggio e lo annuncia
    if (feedback) {
      feedback.scrollIntoView({ block: 'center' });
      feedback.focus({ preventScroll: true });
    }
    if (!form) return;

    var topic = document.getElementById('KojiContactTopic');
    var orderWrap = document.getElementById('KojiOrderField');
    var orderInput = document.getElementById('KojiContactOrder');
    var body = document.getElementById('KojiContactMessage');
    var btn = form.querySelector('.koji-submit-btn');
    var label = form.querySelector('.koji-submit-text');
    var originalLabel = label ? label.textContent : '';

    // Il campo numero ordine compare solo per "Info ordine"
    function syncOrder() {
      if (!topic || !orderWrap || !orderInput) return;
      var show = topic.value === 'Info ordine';
      orderWrap.hidden = !show;
      orderInput.disabled = !show;
    }
    if (topic) {
      topic.addEventListener('change', syncOrder);
      syncOrder();
    }

    form.addEventListener('submit', function () {
      // Argomento e numero ordine finiscono anche nel testo della mail ricevuta
      if (body && body.value.indexOf('Argomento:') !== 0) {
        var nl = String.fromCharCode(10);
        var lines = [];
        if (topic && topic.value) lines.push('Argomento: ' + topic.value);
        if (orderInput && !orderInput.disabled && orderInput.value.trim()) lines.push('Numero ordine: ' + orderInput.value.trim());
        if (lines.length) body.value = lines.join(nl) + nl + nl + body.value;
      }
      if (btn) {
        btn.disabled = true;
        if (label) label.textContent = 'Invio in corso...';
      }
    });

    // Tornando indietro col browser il pulsante deve essere di nuovo attivo
    window.addEventListener('pageshow', function (e) {
      if (e.persisted && btn) {
        btn.disabled = false;
        if (label) label.textContent = originalLabel;
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();